import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Camera, Lock, Send } from "lucide-react";
import { api } from "@/lib/api";
import { useTeam } from "@/lib/team";

// One-tap start: opens Batch with "Send to lister" on. Locked (opens the Team page) unless the Team plan is active.
export default function SendToVaCard() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { canPhotos, isAssistant } = useTeam();
  const [listers, setListers] = useState(null);
  const [isTeam, setIsTeam] = useState(isAssistant);
  useEffect(() => {
    if (!canPhotos) return;
    api.get("/photo-batches/listers", { swr: true }).then(({ data }) => setListers(data.listers || [])).catch(() => setListers([]));
    if (!isAssistant) api.get("/team", { params: { tz: new Date().getTimezoneOffset() }, swr: true }).then(({ data }) => setIsTeam(!!data.is_team)).catch(() => setIsTeam(false));
  }, [canPhotos, isAssistant]);
  if (!canPhotos || listers === null || params.get("edit") || params.get("batch")) return null;
  if (isAssistant && !listers.length) return null;
  const locked = !isTeam;
  const last = (() => { try { return JSON.parse(localStorage.getItem("snaplist.lastSend")) || {}; } catch { return {}; } })();
  const who = listers.find((m) => m.id === last.id)?.name || (listers.length === 1 ? listers[0].name : "your listers");
  const sub = locked ? "Team plan · tap to unlock sending batches to your VA"
    : !listers.length ? "Invite a VA on the Team page to start sending"
    : `Tap, shoot, send to ${who}${last.note ? ` · "${last.note}"` : ""}`;
  const go = () => nav(locked || !listers.length ? "/team" : "/batch?send=1");
  return (
    <div className="mx-auto max-w-5xl px-3 pt-3 sm:px-6">
      <button type="button" onClick={go} data-testid="send-to-va-button" data-locked={locked ? "true" : "false"}
        className={`group flex w-full items-center gap-4 rounded-2xl p-4 text-left shadow-lg transition-transform hover:-translate-y-0.5 active:scale-[0.99] ${locked ? "bg-slate-700 text-slate-200" : "bg-slate-900 text-white"}`}>
        <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-slate-900 transition-transform group-hover:rotate-[-6deg] ${locked ? "bg-slate-300" : "bg-amber-400"}`}>
          {locked ? <Lock className="h-6 w-6" data-testid="send-to-va-lock" /> : <Camera className="h-6 w-6" />}
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-base font-bold">Send photos to my VA</span>
          <span className="block truncate text-xs text-slate-300" data-testid="send-to-va-who">{sub}</span>
        </span>
        {locked ? <span className="shrink-0 rounded-full bg-amber-400 px-2.5 py-1 text-[11px] font-bold text-slate-900" data-testid="send-to-va-upgrade">Unlock</span>
          : <Send className="h-5 w-5 shrink-0 text-amber-400 transition-transform group-hover:translate-x-1" />}
      </button>
    </div>
  );
}
